<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11SOTUX/Images/cover.jpg?1685327666558" alt="This image is the cover for the book Cross the Mountain, The Mountains"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cross the Mountain, The Mountains
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Sequel to Fall Down the Mountain<br/>The Mountains: Book 3.2</i></b></p><p>Allan Tengerdie tumbles down easy ski slopes so often that he doesn’t believe Mark McAvoy’s assurances that he’ll enjoy cross-country skiing. Allan didn’t come to a fancy ski resort to trudge on the flats, but if a soft-in-the-middle chef has a chance to keep up with his ski patrol lover, he really ought to try.</p> <p>Allan and Mark have a great time on the trails, but it’s pleasure for which Allan pays dearly. How will Mark convince him to go again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P.D. Singer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c5093aa